<div class="flex h-full flex-col bg-background-secondary px-6 py-10">
  <div class="flex flex-col border-b border-border-secondary pb-8">
    <h4 class="text-4xl">{{ 'pages.checkout.overview.title' | translate }}</h4>
    @if (subscriptionStartDate() && getVisualSubscriptionEndDate()) {
      <span>
        {{ 'pages.checkout.overview.period' | translate }}:
        {{ subscriptionStartDate() | localizedDate }} -
        {{ getVisualSubscriptionEndDate() | localizedDate }}
      </span>
    }
  </div>
  <div class="grid grid-cols-2 gap-4 border-b border-border-secondary py-8">
    @for (orderLine of orderLines(); track orderLine.product.name) {
      @if (orderLine.seats > 0) {
        <div class="flex basis-3/4 flex-col gap-1 py-1">
          <div class="text-lg font-medium">{{ orderLine.product.name }}</div>
          <div class="text-sm text-link-primary">
            @if (orderLine.isAutoIncludedUpgrade) {
              {{
                getAutoIncludedSummaryKey(orderLine)
                  | translate: getAutoIncludedSummaryParams(orderLine)
              }}
            } @else {
              {{
                'pages.checkout.overview.pricePerUnit'
                  | translate
                    : {
                        amount: orderLine.seats,
                      }
              }}
            }
          </div>
        </div>
        <div class="flex basis-1/4 justify-end self-start py-1 font-medium">
          <span>{{ getPrice(orderLine) | currency: 'EUR' }}</span>
        </div>
      }
    }
    @if (orderLines().length === 0) {
      <div class="text-center text-sm text-text-secondary">
        {{ 'pages.checkout.overview.noProducts' | translate }}
      </div>
    }
  </div>
  @if (!isExemptForVat()) {
    <div class="grid grid-cols-2 gap-4 border-b border-border-secondary py-8">
      <div class="basis-3/4 gap-1 py-1 text-lg font-medium">
        {{ 'pages.checkout.overview.subtotal' | translate }}
      </div>
      <div
        class="flex basis-1/4 flex-col justify-end self-start text-right font-medium whitespace-nowrap"
      >
        <span>{{ getSubtotal() | currency: 'EUR' }}</span>
        @if (isProrated()) {
          <span class="text-right text-sm text-secondary-text">
            {{ 'pages.checkout.overview.totalExcludingVat' | translate }}
          </span>
        } @else {
          <span class="text-right text-sm text-secondary-text">
            {{ 'pages.checkout.overview.totalExcludingVatAYear' | translate }}
          </span>
        }
      </div>
      @for (vatOption of getVatOptions(); track vatOption.rate) {
        <div class="basis-3/4 text-lg font-medium">
          {{
            'pages.checkout.overview.vatWithRate'
              | translate: { rate: vatOption.rate }
          }}
        </div>
        <div
          class="flex basis-1/4 flex-col justify-end self-start text-right font-medium whitespace-nowrap"
        >
          {{ vatOption.amount | currency: 'EUR' }}
        </div>
      }
    </div>
    <div class="flex gap-4 py-8">
      <div class="basis-3/4 text-lg font-medium">
        {{ 'pages.checkout.overview.total' | translate }}
      </div>
      <div
        class="flex basis-1/4 flex-col justify-end self-start text-right font-medium whitespace-nowrap"
      >
        <span>{{ getTotal() | currency: 'EUR' }}</span>
        @if (isProrated()) {
          <span class="text-right text-sm text-secondary-text">
            {{ 'pages.checkout.overview.totalIncludingVat' | translate }}
          </span>
        } @else {
          <span class="text-right text-sm text-secondary-text">
            {{ 'pages.checkout.overview.totalIncludingVatAYear' | translate }}
          </span>
        }
      </div>
    </div>
  } @else {
    <div class="flex gap-4 py-8">
      <div class="basis-3/4 text-lg font-medium">
        {{ 'pages.checkout.overview.total' | translate }}
      </div>
      <div
        class="flex basis-1/4 flex-col justify-end self-start text-right font-medium whitespace-nowrap"
      >
        <span>{{ getSubtotal() | currency: 'EUR' }}</span>
        <span class="text-right text-sm text-secondary-text">
          {{ 'pages.checkout.overview.exemptForVat' | translate }}
        </span>
      </div>
    </div>
  }
  <div class="mt-auto">
    <button
      class="btn-primary btn w-full"
      [disabled]="!canConfirm()"
      (click)="confirm.emit()"
    >
      {{ submitLabelKey() | translate }}
    </button>
  </div>
</div>
